import uniqueId from 'lodash/uniqueId';
import { Dot, LoaderContainer } from './styles';

interface ILoaderProps {
  backgroundColor?: string;
  color?: string;
  over?: boolean;
}

const Loader = ({ backgroundColor, color, over = true }: ILoaderProps) => (
  <LoaderContainer backgroundColor={backgroundColor} over={over} className={'loader'}>
    {[...Array(3)].map((_, index) => (
      <Dot key={uniqueId()} index={index} color={color} />
    ))}
  </LoaderContainer>
);

export default Loader;
